import { render, staticRenderFns } from "./CharactersPopup.vue?vue&type=template&id=001a7a7b&"
import script from "./CharactersPopup.vue?vue&type=script&lang=js&"
export * from "./CharactersPopup.vue?vue&type=script&lang=js&"
import style0 from "./CharactersPopup.vue?vue&type=style&index=0&id=001a7a7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports